import { call, put, takeEvery } from 'redux-saga/effects';

import * as types from './constants';
import * as actions from './actions';
import { fetch, handleErrors } from '../../../api';
import api from '../../../api/endpoints';
import { prepareFilters, segmentFields } from '../helpers';

export const prepareDataTable = data => {
  const dataTable = [];
  const mappedData = data.map(element => {
    return { ...element, selected: false };
  });

  mappedData.forEach(item => {
    const el = {
      key: item.uuid,
      uuid: item.uuid,
      checkbox: { uuid: item.uuid, selected: item.selected },
      link: { name: item.name, url: item.url, image_url: item.image_url, uuid: item.uuid, selected: item.selected },
      creator: item.owner && { ...item.owner, ...segmentFields(item.owner.signals) },
      clicks: item.filtered_clicks,
      sales: item.filtered_gmv,

      date_created: item.created_at,
      tags: item.tags,
      lifetime_clicks: item.lifetime_clicks,
      lifetime_commissions: item.lifetime_commissions,
      lifetime_conversion_rate: item.lifetime_conversion_rate,
      lifetime_gmv: item.lifetime_gmv,
      filtered_clicks: item.filtered_clicks,
      filtered_commissions: item.filtered_commissions,
      filtered_conversion_rate: item.filtered_conversion_rate,
      filtered_gmv: item.filtered_gmv,
      // filtered_modifier_ids: item.filtered_modifier_ids,
      operations: item
    };
    dataTable.push(el);
  });

  return dataTable;
};

function* getPerformanceLinks({ payload: { signal, filters, searchQ, curr_page, onSuccess } }) {

  try {
    const { data } = yield call(fetch, {
      api: api.analytics.links,
      data: {
        ...prepareFilters(filters),
        include_comparison: true,
        q: searchQ,
        page: curr_page > 0 ? curr_page - 1 : 0
      },
      signal
    });

    const preparedData = {
      next: data.next,
      previous: data.previous,
      count: data.count,
      message: data.message,
      dataTable: prepareDataTable(data.results),
      apiFilters: data.filters
      // campaign_modifiers: data.campaign_modifiers
    };

    onSuccess && onSuccess(data);

    yield put(actions.getPerformanceLinksDone(preparedData));
  } catch (error) {
    yield handleErrors({
      error,
      putErrorData: actions.getPerformanceLinksFailed,
      endpoint: api.analytics.links.url
    });
  }
}

export const getPerformanceLinksSaga = takeEvery(types.GET_PERFORMANCE_LINKS_REQUEST, getPerformanceLinks);


